import { Component, OnInit } from '@angular/core';
import { CEDIS_LIST } from '../../utils';
import { TranslateModule } from '@ngx-translate/core';

import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-cedis-modal',
    templateUrl: './cedis-modal.component.html',
    styleUrls: ['./cedis-modal.component.scss'],
    standalone: true,
    imports: [MatIconModule, MatDialogModule, TranslateModule]
})
export class CedisModalComponent implements OnInit {

  public cedisOptions = CEDIS_LIST;

  constructor() { }

  ngOnInit(): void {
  }

}
